import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-recursive-list',
    templateUrl: './recursive-list.component.html',
    styleUrls: ['./recursive-list.component.scss'],
    standalone: false
})
export class RecursiveList implements OnInit {

  @Input() list: any[] = [];

  constructor() {}

  ngOnInit() {
  }

}
